/**
 * assets/focus-trap.js
 * Gedrag van snippets/focus-trap.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

/* Laatste element met focus. Valt terug als de knop die een lade opende op het
   moment van openen even geen focus had: "In winkelwagen" is tijdens het toevoegen
   disabled, dan staat de focus op body. Gemeten 27-10-2026 (toetsenbordtest, project
   Design en UX 2027): na Escape kwam de focus op body in plaats van op de knop. */
let vcLaatsteFocus = null;
const vcActieveVallen = new Set();
document.addEventListener('focusin', (e) => {
  const t = e.target;
  if (!t || t === document.body) return;
  for (const val of vcActieveVallen) if (val.contains(t)) return; /* focus binnen een open lade telt niet */
  vcLaatsteFocus = t;
}, true);

class FocusTrap {
  constructor(element) {
    this.el = element;
    this.handleKeydown = this.handleKeydown.bind(this);
    this.previouslyFocused = null;
  }

  activate() {
    const nu = document.activeElement;
    const bruikbaar = (el) => el && el !== document.body && !this.el.contains(el);
    this.previouslyFocused = bruikbaar(nu) ? nu : (bruikbaar(vcLaatsteFocus) ? vcLaatsteFocus : null);
    this.el.addEventListener('keydown', this.handleKeydown);
    vcActieveVallen.add(this.el);
    /* Focus first focusable element*/
    const first = this.getFocusable()[0];
    if (first) first.focus();
  }

  deactivate() {
    this.el.removeEventListener('keydown', this.handleKeydown);
    vcActieveVallen.delete(this.el);
    const terug = this.previouslyFocused;
    if (terug && terug.isConnected && typeof terug.focus === 'function') {
      try { terug.focus(); } catch (_) {}
    }
  }

  handleKeydown(e) {
    if (e.key !== 'Tab') return;

    const focusable = this.getFocusable();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  getFocusable() {
    const selectors = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return [...this.el.querySelectorAll(selectors)].filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
  }
}

/* Expose globally*/
window.FocusTrap = FocusTrap;
